import { uploadImage } from '../apis/Article.js'
import { validateFile, processImage } from './ImageOptimizer.js'
class CkImageUploadAdapter
{
    constructor (loader)
    {
        // The file loader instance to use during the upload.
        this.loader = loader;
    }

    // Starts the upload process.
    upload ()
    {
        return new Promise((resolve, reject) =>
        {
            const reader = new window.FileReader();
            reader.addEventListener('load', () =>
            {
              processImage(reader.result, (data) => {
                uploadImage(data).then(
                  (response) => { console.log(response.data.url); resolve({'default': response.data.url}) },
                  () => reject('Something went wrong. Please try again')
                )
              }, 900)
            });

            reader.addEventListener('error', err =>
            {
                reject(err);
            });

            reader.addEventListener('abort', () =>
            {
                reject();
            });

            this.loader.file.then(file =>
            {
              var error = validateFile(file)
              if(error) {
                reject(error)
                return;
              }
              reader.readAsArrayBuffer(file);
            });
        });
    }

    // Aborts the upload process.
    abort ()
    {
         //
    }
}

const plugin = function (editor)
{
    editor.plugins.get('FileRepository').createUploadAdapter = (loader) =>
        new CkImageUploadAdapter(loader);
};

export default plugin;
